<template>
  <div class="info-container">
    <div
      v-for="item in alerts"
      :key="item.id"
      class="alert-row hover-lighten"
      @click="handleItemClick(item)"
    >
      <!-- Conteneur des actions aligné à gauche -->
      <div class="action-button" :style="{ 'no-background-color': severityColor(item.severity) }">
        <v-btn
          v-if="isAcked(item.status) || isClosed(item.status)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="takeAction(item.id, 'open')"
        >
          <v-icon :size="fontSize">refresh</v-icon>
        </v-btn>
        <v-btn
          v-if="!isWatched(item.tags)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="watchAlert(item.id)"
        >
          <v-icon :size="fontSize">visibility</v-icon>
        </v-btn>
        <v-btn
          v-if="isWatched(item.tags)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="unwatchAlert(item.id)"
        >
          <v-icon :size="fontSize">visibility_off</v-icon>
        </v-btn>
        <v-btn
          v-if="isOpen(item.status)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="ackAlert(item.id)"
        >
          <v-icon :size="fontSize">check</v-icon>
        </v-btn>
        <v-btn
          v-if="isAcked(item.status)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="takeAction(item.id, 'unack')"
        >
          <v-icon :size="fontSize">undo</v-icon>
        </v-btn>
        <v-btn
          v-if="isOpen(item.status) || isAcked(item.status)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="shelveAlert(item.id)"
        >
          <v-icon :size="fontSize">schedule</v-icon>
        </v-btn>
        <v-btn
          v-if="isShelved(item.status)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="takeAction(item.id, 'unshelve')"
        >
          <v-icon :size="fontSize">restore</v-icon>
        </v-btn>
        <v-btn
          v-if="!isClosed(item.status)"
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="takeAction(item.id, 'close')"
        >
          <v-icon :size="fontSize">highlight_off</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="selectItem(item)"
        >
          <v-icon :size="fontSize">history</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          small
          class="btn--plain pa-0 ma-0"
          @click.stop="deleteAlert(item.id)"
        >
          <v-icon :size="fontSize">delete</v-icon>
        </v-btn>
        <v-menu bottom left>
          <v-btn
            slot="activator"
            flat
            icon
            small
            class="btn--plain pa-0 ma-0"
          >
            <v-icon small>more_vert</v-icon>
          </v-btn>
          <v-list subheader>
            <v-subheader>Actions</v-subheader>
            <v-divider />
            <v-list-item
              v-for="(action, i) in actions"
              :key="i"
              @click.stop="takeAction(item.id, action)"
            >
              <v-list-item-title>{{ action | splitCaps }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div 
        class="alert-grid"
        :class="!isAcked(item.status) ? 'blink' : ''"
        :style="!isAcked(item.status) ? backgroudDregrad(item.severity) : ''"
      >
        <div 
          class="alert-cell grid1"
          :style="{ 'background-color': severityColor(item.severity) }"
        ></div> 
        <div class="alert-cell">
          <span
            :class="['label', 'label-' + item.severity.toLowerCase()]"
            :style="fontStyle"
          >
            {{ translateSeverity(item.severity) }}
          </span>
        </div>
        <div
          v-if="!checkTicket(item.id)"
          class="alert-cell border-separator-left click"
          @click.stop="createTicket(item)"
        >
          Créer
        </div>
        <div
          v-else
          class="alert-cell border-separator-left click"
          @click.stop="openTicket(item.id)"
        >
          {{ checkTicket(item.id) }}
        </div> 
        <div class="alert-cell border-separator-left">{{ item.client || 'InfoGenius' }}</div> 
        <div class="alert-cell border-separator-left">
          <date-time
            :value="item.receiveTime"
            format="mediumDate"
          />
        </div>
        <div class="alert-cell">{{ item.service.join(', ') }}</div>
        <div class="alert-cell">{{ item.text }}</div>
        <!-- Deuxième ligne d'informations -->
        <div class="alert-cell border-separator">
          <span
            v-if="isOpen(item.status)"
            class="label click"
            :style="fontStyle"
            @click.stop="ackAlert(item.id)"
          >
            {{ item.status | capitalize }}
          </span>
          <span
            v-if="isAcked(item.status)"
            class="label click"
            :style="fontStyle"
            @click.stop="takeAction(item.id, 'unack')"
          >
            {{ item.status | capitalize }}
          </span>
        </div>
        <div class="alert-cell border-separator">
          {{ timeoutLeft(item) | hhmmss }}
        </div>
        <div class="alert-cell border-separator">{{ item.environment }}</div>
        <div class="alert-cell border-separator">{{ item.duplicateCount }}</div>
        <div class="alert-cell">{{ item.resource }}</div>
        <div class="alert-cell">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import get from 'lodash/get'
import DateTime from './lib/DateTime'
import moment from 'moment'
import i18n from '@/plugins/i18n'
import axios from 'axios'

export default {
  components: {
    DateTime
  },
  props: {
    alerts: {
      type: Array,
      default: () => []
    }
  },
  data: vm => ({
    search: '',
    headersMap: {
      id: { text: i18n.t('AlertId'), value: 'id' },
      resource: { text: i18n.t('Resource'), value: 'resource' },
      event: { text: i18n.t('Event'), value: 'event' },
      environment: { text: i18n.t('Environment'), value: 'environment' },
      severity: { text: i18n.t('Severity'), value: 'severity' },
      correlate: { text: i18n.t('Correlate'), value: 'correlate' },
      status: { text: i18n.t('Status'), value: 'status' },
      service: { text: i18n.t('Service'), value: 'service' },
      group: { text: i18n.t('Group'), value: 'group' },
      value: { text: i18n.t('Value'), value: 'value', class: 'value-header' },
      text: { text: i18n.t('Description'), value: 'text', class: 'text-header' },
      tags: { text: i18n.t('Tags'), value: 'tags' },
      attributes: { text: i18n.t('Attribute'), value: 'attributes' },
      origin: { text: i18n.t('Origin'), value: 'origin' },
      type: { text: i18n.t('Type'), value: 'type' },
      createTime: { text: i18n.t('CreateTime'), value: 'createTime' },
      timeout: { text: i18n.t('Timeout'), value: 'timeout' },
      timeoutLeft: { text: i18n.t('TimeoutLeft'), value: 'timeoutLeft' },
      customer: { text: i18n.t('Customer'), value: 'customer' },
      duplicateCount: { text: i18n.t('Dupl'), value: 'duplicateCount' },
      repeat: { text: i18n.t('Repeat'), value: 'repeat' },
      previousSeverity: { text: i18n.t('PrevSeverity'), value: 'previousSeverity' },
      trendIndication: { text: i18n.t('TrendIndication'), value: 'trendIndication' },
      receiveTime: { text: i18n.t('ReceiveTime'), value: 'receiveTime' },
      duration: { text: i18n.t('Duration'), value: 'duration' },
      lastReceiveId: { text: i18n.t('LastReceiveId'), value: 'lastReceiveId' },
      lastReceiveTime: { text: i18n.t('LastReceiveTime'), value: 'lastReceiveTime' },
      note: { text: i18n.t('LastNote'), value: 'note', sortable: false }
    },
    details: false,
    selectedId: null,
    multiselect: false,
    timer: null
  }),
  computed: {
    displayDensity() {
      return (
        this.$store.getters.getPreference('displayDensity') ||
        this.$store.state.alerts.displayDensity
      )
    },
    fontStyle() {
      const font = this.$store.getters.getPreference('font')
      return {
        'font-family': font['font-family'],
        'font-size': font['font-size'],
        'font-weight': font['font-weight']
      }
    },
    fontSize() {
      return this.$store.getters.getPreference('font')['font-size']
    },
    columnWidths() {
      return {
        '--value-width': this.valueWidth() + 'px',
        '--text-width': this.textWidth() + 'px'
      }
    },
    isLoading() {
      return this.$store.state.alerts.isLoading
    },
    isSearching() {
      return this.$store.state.alerts.isSearching ? 'primary' : false
    },
    showNotesIcon() {
      return this.$store.getters.getPreference('showNotesIcon')
    },
    rowsPerPage() {
      return this.$store.getters.getPreference('rowsPerPage')
    },
    pagination: {
      get() {
        return this.$store.state.alerts.pagination
      },
      set(value) {
        this.$store.dispatch('alerts/setPagination', value)
      }
    },
    actions() {
      return this.$config.actions
    },
    customHeaders() {
      return this.$config.columns.map(c =>
        this.headersMap[c] || { text: this.$options.filters.capitalize(c), value: 'attributes.' + c }
      )
    },
    selectedItem() {
      return this.alerts.filter(a => a.id == this.selectedId)[0]
    },
    selectableRows() {
      return this.selected.length > 0
    },
    selected: {
      get() {
        return this.$store.state.alerts.selected
      },
      set(value) {
        this.$store.dispatch('alerts/updateSelected', value)
      }
    },
    ackTimeout() {
      return this.$store.getters.getPreference('ackTimeout')
    },
    shelveTimeout() {
      return this.$store.getters.getPreference('shelveTimeout')
    },
    username() {
      return this.$store.getters['auth/getUsername']
    }
  },
  watch: {
    rowsPerPage(val) {
      this.pagination = Object.assign({}, this.pagination, {rowsPerPage: val})
    }
  },
  methods: {
    tickets: [],
    openTicket(id) {
      //https://support.infogenius.network/scp/tickets.php?id=
      const nb = (this.tickets[id].total - 1)
      const url = 'https://support.infogenius.network/scp/tickets.php?id=' + this.tickets[id].tickets[nb].ticket_id
      window.open(url, '_blank')
    },
    checkTicket(id) {
      if (this.tickets[id] === undefined) {
        // ici on lance le processe de récupération
        this.demandTickets(id)
      } else {

        // On a déjà une info de stocké ?
        if (this.tickets[id] == null) {
          //console.log('Ticket on a quelque chose ! Ticket: id: ', id, this.tickets[id])
          return false
        }
        const nb = (this.tickets[id].total - 1)
        if (this.tickets[id].tickets[nb].alert_id === id) {
          //console.log('Ticket existe for ', id, this.tickets[id])
          return this.tickets[id].tickets[nb].number
        }
      }
      return false 
    },
    async demandTickets(id) {
      await axios.get('https://support.infogenius.network/ost_wbs/api.php', {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'apikey': '12B7866D8006E052ABC595EF17195C40', // Remplacez par votre token d'API
        },
        params: {
          'id': id
        }
      }).then(response => {
        // Reponse 200 = OK 
        if (response.status === 200) {
          this.tickets[id] = response.data.data // Ticket trouvé
        } else {
          this.tickets[id] = null // Ticket trouvé
        }
      }).catch(error => {
        this.tickets[id] = null
        console.error('Erreur lors de la vérification du ticket:', error)
      })
    },
    async createTicket(item) {
      const newTicketData = {
        query: 'ticket',
        condition: 'add',
        parameters: {
          mail: this.username,
          priority_id: this.translateSeverityPriority(item.severity),
          status_id: 1,
          dept_id: 1,
          sla_id: 1,
          topic_id: 10,
          alert_id: item.id,
          title: `Ticket pour l'Alerte ID: ${item.id}`,
          subject: `[SUPERVISION] ${item.event}`,
          body: `<p>Bonjour cher client,</p>
<p>Un incident a été détecté et a entraîné l'ouverture de ce ticket. Nous sommes actuellement en train d'évaluer la situation et de travailler activement à la résolution du problème.</p>
<p>Nous vous tiendrons informés de l'évolution de la situation et de la progression des efforts de résolution. Merci de votre compréhension et de votre patience pendant que nous travaillons à résoudre cet incident.</p>
<br/><p>Cordialement,<br/>L'équipe de support</p>
          `
        },
      }

      await axios.post('https://support.infogenius.network/ost_wbs/api.php', newTicketData, {
        headers: {
          'Content-Type': 'application/json',
          'apikey': '12B7866D8006E052ABC595EF17195C40', // Remplacez par votre token d'API
        },
      }).then(response => {
        // Reponse 200 = OK 
        if (response.status === 200) {
          this.tickets[item.id] = response.data.data // Ticket trouvé
        } else {
          this.tickets[item.id] = null // Ticket trouvé
        }
      }).catch(error => {
        this.error = error.message // Enregistrer l'erreur pour affichage
        console.error('Erreur lors de la création du ticket :', error)
      })
    },
    translateSeverityPriority(severity) {
      if (severity == 'warning') {
        return '1'
      }
      if (severity == 'minor') {
        return '2'
      }
      if (severity == 'major') {
        return '3'
      }
      if (severity == 'critical') {
        return '4'
      }
      return '1'
    },
    handleItemClick(item) {
      console.log(item) // Affiche le contenu de l'item dans la console
      console.log('Ticket info: ', this.tickets[item.id])
    },
    duration(item) {
      return moment.duration(moment().diff(moment(item.receiveTime)))
    },
    translateSeverity(severity) {
      if (severity == 'warning') {
        return 'P4'
      }
      if (severity == 'minor') {
        return 'P3'
      }
      if (severity == 'major') {
        return 'P2'
      }
      if (severity == 'critical') {
        return 'P1'
      }
      return 'Px'
    },
    backgroudDregrad(severity) {
      if (severity == 'warning') {
        return 'background: linear-gradient(to right, rgba(30, 144, 255, 0.29), rgba(48, 48, 48, 0));'
      }
      if (severity == 'minor') {
        return 'background: linear-gradient(to right, rgba(255, 204, 0, 0.29), rgba(48, 48, 48, 0))'
      }
      if (severity == 'major') {
        return ''
      }
      if (severity == 'critical') {
        return ''
      }
    },
    timeoutLeft(item) {
      let ackedOrShelved = this.isShelved(item.status) || this.isAcked(item.status)
      let lastModified = ackedOrShelved && item.updateTime ? item.updateTime : item.lastReceiveTime
      let expireTime = moment(lastModified).add(item.timeout, 'seconds')
      return expireTime.isAfter() ? expireTime.diff(moment(), 'seconds') : moment.duration()
    },
    lastNote(item) {
      const note = item.history.filter(h => h.type == 'note' || h.type == 'dismiss').pop()
      return note && note.type == 'note' ? note.text : ''
    },
    valueWidth() {
      return this.$store.getters.getPreference('valueWidth')
    },
    textWidth() {
      return this.$store.getters.getPreference('textWidth')
    },
    textColor(severity) {
      return 'white--text'
      if (this.severityColor(severity) === 'black' || this.severityColor(severity) === '#000000') {
        return 'white--text'
      }
      return this.$store.getters.getConfig('colors').text
        ? `${this.$store.getters.getConfig('colors').text}--text`
        : ''
    },
    severityColor(severity) {
      return this.$store.getters.getConfig('colors').severity[severity] || 'white'
    },
    selectItem(item) {
      if (!this.selected.length) {
        this.$emit('set-alert', item)
      }
    },
    isOpen(status) {
      return status == 'open' || status == 'NORM' || status == 'UNACK' || status == 'RTNUN'
    },
    isWatched(tags) {
      return tags ? tags.indexOf(`watch:${this.username}`) > -1 : false
    },
    isAcked(status) {
      return status == 'ack' || status == 'ACKED'
    },
    isShelved(status) {
      return status == 'shelved' || status == 'SHLVD'
    },
    isClosed(status) {
      return status == 'closed'
    },
    takeAction: debounce(function(id, action) {
      this.$store
        .dispatch('alerts/takeAction', [id, action, ''])
        .then(() => this.$store.dispatch('alerts/getAlerts'))
    }, 200, {leading: true, trailing: false}),
    ackAlert: debounce(function(id) {
      this.$store
        .dispatch('alerts/takeAction', [id, 'ack', '', this.ackTimeout])
        .then(() => this.$store.dispatch('alerts/getAlerts'))
    }, 200, {leading: true, trailing: false}),
    shelveAlert: debounce(function(id) {
      this.$store
        .dispatch('alerts/takeAction', [id, 'shelve', '', this.shelveTimeout])
        .then(() => this.$store.dispatch('alerts/getAlerts'))
    }, 200, {leading: true, trailing: false}),
    watchAlert: debounce(function(id) {
      this.$store
        .dispatch('alerts/watchAlert', id)
        .then(() => this.$store.dispatch('alerts/getAlerts'))
    }, 200, {leading: true, trailing: false}),
    unwatchAlert: debounce(function(id) {
      this.$store
        .dispatch('alerts/unwatchAlert', id)
        .then(() => this.$store.dispatch('alerts/getAlerts'))
    }, 200, {leading: true, trailing: false}),
    deleteAlert: debounce(function(id) {
      confirm(i18n.t('ConfirmDelete')) &&
        this.$store.dispatch('alerts/deleteAlert', id)
          .then(() => this.$store.dispatch('alerts/getAlerts'))
    }, 200, {leading: true, trailing: false}),
    clipboardCopy(text) {
      let textarea = document.createElement('textarea')
      textarea.textContent = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
    }
  }
}
</script>

<style>
.alert-table .v-table th, td {
  padding: 0px 5px !important;
}

.value-header {
  width: var(--value-width);
  min-width: var(--value-width);
}

.text-header {
  width: var(--text-width);
  min-width: var(--text-width);
}

.comfortable table.v-table tbody td, table.v-table tbody th {
  height: 42px !important;
}

.compact table.v-table tbody td, table.v-table tbody th {
  height: 34px !important;
}

.alert-table .v-table tbody td {
  border-top: 1px solid rgb(221, 221, 221);
}

.fixed-table {
  display: table;
  table-layout: fixed;
  width: 100%;
}

i.trend-arrow {
  width: 24px !important;
}

div.select-box {
  width: 24px !important;
}

.label {
  font-weight: bold;
  line-height: 14px;
  color: #ffffff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  white-space: nowrap;
  vertical-align: baseline;
  background-color: #999999;
}

.label {
  padding: 1px 4px 2px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.label-critical {
  background-color: #b94a48;
}

.label-major {
  background-color: #f89406;
}

.label-minor {
  background-color: #b89b00;
}

.label-warning {
  background-color: #3a87ad;
}

.label-normal,
.label-cleared,
.label-ok,
.label-informational {
  background-color: #468847;
}

.label-inverse {
  background-color: #333333;
}

.hover-lighten:hover {
  filter: brightness(0.87);
}

.btn--plain {
  height: auto;
  width: auto;
  margin: 0;
  padding: 8px;
  min-width: 0;
  font-size: 24px;
}
.btn--plain {
  padding: 0;
  opacity: 0.6;
}
.btn--plain:before {
  background-color: transparent !important;
  transition: none !important;
}
.btn--plain:hover {
  opacity: 1;
}

div.action-buttons {
  position: absolute;
  opacity: 0;
  right: 0;
  top: 0.5em;
  height: 2em;
}

tr:hover div.action-buttons {
  opacity: 1;
}
@-webkit-keyframes blinker {
  from {opacity: 1.0;}
  to {opacity: 0.3;}
}
.blink{
	text-decoration: blink;
	-webkit-animation-name: blinker;
	-webkit-animation-duration: 0.8s;
	-webkit-animation-iteration-count:infinite;
	-webkit-animation-timing-function:ease-in-out;
	-webkit-animation-direction: alternate;
}
.alert-container {
  max-width: 100%; /* Largeur maximale de la boîte d'alerte */
  margin: 0 auto; /* Centrer la boîte d'alerte */
  padding: 10px; /* Espacement interne */
  overflow-y: auto; /* Permettre le défilement vertical si nécessaire */
}

.alert-grid {
  display: grid; /* Utiliser CSS Grid pour la disposition */
  grid-template-rows: auto auto; /* Deux lignes pour le contenu */
  grid-template-columns: 10px 60px 1fr 1fr 1fr 5fr 10fr; /* Cinq colonnes pour la première ligne */
  padding: 5px 0; /* Espacement vertical entre les alertes */
  border-bottom: 1px solid #6a6a6a; /* Bordure légère pour séparer les lignes */

}

.grid1 {
  grid-row: 1 / 3;
}

.alert-cell {
  padding: 5px; /* Espacement interne dans les cellules */
}

.border-separator-left {
  border-left: 0.5px solid #4b4b4b; /* Bordure gauche */
}

.border-separator {
  border-top: 0.5px solid #4b4b4b; /* Bordure entre les lignes */
  border-left: 0.5px solid #4b4b4b; /* Bordure gauche */
}

.border-separator:first-child {
  border-left: none; /* Pas de bordure à gauche pour la première cellule */
}

.top-row {
  font-weight: bold; /* Texte en gras pour la première ligne */
}

.click {
  cursor: pointer; /* Changer le curseur pour indiquer un clic */
}

.bottom-row {
  color: #555; /* Texte de la deuxième ligne en gris */
}

.action-button {
  display: flex; /* Utiliser flexbox pour aligner les boutons d'action */
  align-items: center; /* Centrer les boutons verticalement */
  margin-bottom: 5px; /* Espacement en bas des boutons */
  position: absolute;
  right: 0px;
  height: 2em;
  /*z-index: 10000;*/
}

.hover-lighten:hover {
  background-color: #28282880; /* Changer la couleur de fond au survol */
}
</style>
